/**
 * Cantica Divina social icons (brand glyphs as inline SVG paths).
 * License: AGPL-3.0-or-later (see repository LICENSE)
 */

type IconProps = { className?: string; size?: number };

const base = (props: IconProps) => ({
  width: props.size ?? 20,
  height: props.size ?? 20,
  fill: "currentColor",
  viewBox: "0 0 24 24",
  className: props.className,
  "aria-hidden": true as const,
});

export const InstagramIcon = (p: IconProps) => (
  <svg {...base(p)}>
    <path d="M12 2.2c3.2 0 3.6 0 4.8.07 1.2.05 1.8.24 2.2.4.6.22 1 .48 1.4.9.4.4.7.9.9 1.4.16.42.36 1.06.4 2.23.07 1.27.07 1.65.07 4.85s0 3.58-.07 4.85c-.04 1.17-.24 1.8-.4 2.22-.2.56-.48 1-.9 1.4-.4.42-.86.7-1.4.9-.42.17-1.06.36-2.23.42-1.26.06-1.64.06-4.84.06s-3.58 0-4.85-.06c-1.17-.06-1.8-.25-2.22-.42a3.8 3.8 0 0 1-1.4-.9 3.7 3.7 0 0 1-.9-1.4c-.17-.42-.36-1.05-.42-2.22C2.07 15.58 2 15.2 2 12s.07-3.58.13-4.85c.06-1.17.25-1.8.42-2.22.2-.56.48-1 .9-1.4.4-.42.85-.7 1.4-.9.4-.17 1.05-.36 2.22-.42C8.42 2.2 8.8 2.2 12 2.2m0-2.2C8.74 0 8.33 0 7.05.07 5.78.13 4.9.33 4.14.63a5.9 5.9 0 0 0-2.16 1.4A5.9 5.9 0 0 0 .57 4.2C.27 4.95.07 5.83 0 7.1-.05 8.38 0 8.8 0 12.05s0 3.67.07 4.95c.06 1.27.26 2.15.56 2.9.3.8.72 1.47 1.4 2.16a5.9 5.9 0 0 0 2.15 1.4c.76.3 1.64.5 2.9.57 1.29.06 1.7.06 4.96.06s3.67 0 4.95-.06c1.27-.07 2.15-.27 2.9-.57a5.9 5.9 0 0 0 2.16-1.4 5.9 5.9 0 0 0 1.4-2.15c.3-.76.5-1.64.57-2.9.06-1.3.06-1.7.06-4.96s0-3.67-.06-4.95c-.07-1.27-.27-2.15-.57-2.9a5.9 5.9 0 0 0-1.4-2.16A5.9 5.9 0 0 0 19.85.57c-.76-.3-1.64-.5-2.9-.57C15.66 0 15.25 0 12 0z" />
    <path d="M12 5.84A6.16 6.16 0 1 0 18.16 12 6.16 6.16 0 0 0 12 5.84M12 16a4 4 0 1 1 4-4 4 4 0 0 1-4 4M19.85 5.6a1.44 1.44 0 1 1-1.44-1.44 1.44 1.44 0 0 1 1.44 1.44" />
  </svg>
);

export const TikTokIcon = (p: IconProps) => (
  <svg {...base(p)}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64c.3 0 .58.04.85.13V9.4a6.33 6.33 0 0 0-5.4 10.92 6.33 6.33 0 0 0 10.86-4.43V9.75a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-.97-.18z" />
  </svg>
);

export const YouTubeIcon = (p: IconProps) => (
  <svg {...base(p)}>
    <path d="M23.5 6.19a3.02 3.02 0 0 0-2.12-2.14C19.5 3.55 12 3.55 12 3.55s-7.5 0-9.38.5A3.02 3.02 0 0 0 .5 6.19C0 8.07 0 12 0 12s0 3.93.5 5.81a3.02 3.02 0 0 0 2.12 2.14c1.87.5 9.38.5 9.38.5s7.5 0 9.38-.5a3.02 3.02 0 0 0 2.12-2.14C24 15.93 24 12 24 12s0-3.93-.5-5.81zM9.55 15.57V8.43L15.82 12l-6.27 3.57z" />
  </svg>
);

export const XIcon = (p: IconProps) => (
  <svg {...base(p)}>
    <path d="M18.9 1.15h3.68l-8.04 9.19L24 22.85h-7.4l-5.8-7.58-6.64 7.58H.47l8.6-9.83L0 1.15h7.6l5.24 6.93zm-1.3 19.5h2.04L6.49 3.24H4.3z" />
  </svg>
);

export const BandcampIcon = (p: IconProps) => (
  <svg {...base(p)}>
    <path d="M0 18.75l7.44-13.5H24l-7.44 13.5z" />
  </svg>
);

export const SoundCloudIcon = (p: IconProps) => (
  <svg {...base(p)}>
    <path d="M1.17 12.42c-.06 0-.1.05-.11.11l-.29 2.2.29 2.16c.01.06.05.11.11.11.06 0 .1-.05.11-.11l.34-2.16-.34-2.2c-.01-.06-.05-.11-.11-.11zm1.9-1.16c-.07 0-.12.05-.13.12l-.39 3.35.39 3.24c.01.07.06.12.13.12s.12-.05.13-.12l.44-3.24-.44-3.35c-.01-.07-.06-.12-.13-.12zm2.04-.44c-.08 0-.14.06-.15.14l-.36 3.77.36 3.63c.01.08.07.14.15.14.08 0 .14-.06.15-.14l.41-3.63-.41-3.77c-.01-.08-.07-.14-.15-.14zm2.07-.2c-.09 0-.16.07-.17.16l-.34 3.95.34 3.77c.01.09.08.16.17.16.09 0 .16-.07.17-.16l.38-3.77-.38-3.95c-.01-.09-.08-.16-.17-.16zm2.1-.94c-.1 0-.18.08-.19.18l-.31 4.87.31 3.71c.01.1.09.18.19.18s.18-.08.19-.18l.35-3.71-.35-4.87c-.01-.1-.09-.18-.19-.18zm2.12-1.31c-.11 0-.2.09-.21.2l-.29 6.17.29 3.66c.01.11.1.2.21.2.11 0 .2-.09.21-.2l.32-3.66-.32-6.17c-.01-.11-.1-.2-.21-.2zm2.4-1.32c-.12 0-.22.1-.23.22l-.25 7.47.25 3.59c.01.12.11.22.23.22.12 0 .22-.1.23-.22l.28-3.59-.28-7.47a.23.23 0 0 0-.23-.22zm4.83 2.9c-.51 0-1 .1-1.44.29-.3-3.36-3.12-6-6.57-6-.84 0-1.66.16-2.4.44-.28.11-.36.22-.36.44v11.51c0 .23.18.42.41.44h10.36A3.56 3.56 0 0 0 24 13.5a3.56 3.56 0 0 0-3.37-3.55z" />
  </svg>
);
